import { Flex, Show } from "@chakra-ui/react";
import React from "react";
import Button from "../../../shared/components/ui/Button";
import SmsIcon from "../../../shared/components/icons/SmsIcon";

const SpTalkMessageButton = () => {
  return (
    <Show below="lg">
      <Flex
        position="sticky"
        bottom={0}
        w="100%"
        p={4}
        justifyContent="center"
        bgColor="rgba(179, 221, 211, 0.9)"
        zIndex={100}
      >
        <Button leftIcon={<SmsIcon boxSize={5} />} w="full">
          お問い合わせする
        </Button>
      </Flex>
    </Show>
  );
};

export default SpTalkMessageButton;
